import { configureStore } from "@reduxjs/toolkit";
import chatReducer from './chatSlice';
import socketMiddleware from './socketMiddleware';

const store = configureStore({
    reducer: {
        chat: chatReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(socketMiddleware),
});

export default store;
